export enum BiOrderStatus {
    NEWC=30, // 新客户
    RUNNING = 31, // 磨合
    UP = 32, // /上涨
    DOWN = 33, // 下降
    STABLE=34, // 稳定
    FLAT = 35, // 持平
    LOSS = 36, // 流失

  }
